import { Pipe, PipeTransform } from "@angular/core";
import {
  ReportDesignerItemImageValue,
  ReportDesignItemConfig
} from "../../report-design-item";

@Pipe({
  name: "asImageValue",
  standalone: false
})
export class ReportItemConfigAsImageValuePipe implements PipeTransform {
  transform(value: ReportDesignItemConfig): ReportDesignerItemImageValue {
    return <ReportDesignerItemImageValue>value;
  }
}
